import styled, { keyframes } from "styled-components";
import { Button } from "../../Buttons/Button";

export const Title = styled.h2`
  color: ${({ theme }) => theme.textLight};
  font-family: ${({ theme }) => theme.fontHeavy};
  font-size: 22px;
  text-align: center;
  margin: 0 0 8px 0;
`;

export const Subtitle = styled.p`
  color: ${({ theme }) => theme.textMedium};
  font-family: ${({ theme }) => theme.fontMedium};
  font-size: 13px;
  text-align: center;
  margin: 0 0 24px 0;
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const DropZone = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 460px;
  max-width: 100%;
  height: 200px;
  border: 1.5px dashed
    ${({ theme, $dragging }) => ($dragging ? theme.primary : theme.textDark)};
  border-radius: 8px;
  background-color: ${({ theme, $dragging }) =>
    $dragging ? theme.backgroundLight : theme.backgroundDark};
  cursor: pointer;
  padding: 24px;
  animation: ${fadeInUp} 0.18s ease;
  transition: border-color 0.18s ease, background-color 0.18s ease;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    background-color: ${({ theme }) => theme.backgroundLight};
  }
`;

export const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const DropZoneIcon = styled.div`
  color: ${({ theme }) => theme.textMedium};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropZonePrimary = styled.div`
  color: ${({ theme }) => theme.textLight};
  font-family: ${({ theme }) => theme.fontMedium};
  font-size: 15px;
  text-align: center;

  .browse {
    color: ${({ theme }) => theme.primary};
    text-decoration: underline;
  }
`;

export const DropZoneHelper = styled.div`
  color: ${({ theme }) => theme.textMedium};
  font-family: ${({ theme }) => theme.fontMedium};
  font-size: 12px;
  text-align: center;
`;

export const SelectedFile = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: ${({ theme }) => theme.backgroundLight};
  border: 1px solid ${({ theme }) => theme.backgroundLight};
  border-radius: 8px;
  padding: 16px 18px;
  animation: ${fadeInUp} 0.18s ease;

  .file-icon {
    color: ${({ theme }) => theme.primary};
    flex-shrink: 0;
    display: flex;
  }

  .meta {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .name {
    color: ${({ theme }) => theme.textLight};
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .size {
    color: ${({ theme }) => theme.textMedium};
    font-size: 12px;
  }

  .remove {
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.textMedium};
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 13px;
    padding: 4px 8px;

    &:hover {
      color: ${({ theme }) => theme.textLight};
    }
  }
`;

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.danger};
  font-family: ${({ theme }) => theme.fontMedium};
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;

  .link {
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.textMedium};
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 14px;
    padding: 8px 4px;
  }

  .link:hover {
    color: ${({ theme }) => theme.textLight};
  }
`;

export const UploadButton = styled(Button)`
  cursor: pointer;

  &:disabled {
    background-color: ${({ theme }) => theme.backgroundDark} !important;
    color: ${({ theme }) => theme.grey2} !important;
    cursor: default !important;
  }

  &&:disabled:hover {
    transform: none;
  }
`;
